// Reimplemented from eb-ui `@eventbrite/eds-pagination` (no react-19 Valkyrie home).
// Same contract the eb-ui TrendingSearches used: pageNumber / pageCount / onSelected /
// showOnSinglePage. Renders prev/next + numbered page buttons; renders nothing on a
// single page when showOnSinglePage is false (the eb-ui default).

import React from 'react';

interface PaginationProps {
    pageNumber: number;
    pageCount: number;
    onSelected: (pageNumber: number) => void;
    resultsPerPage?: number;
    totalNumResults?: number;
    showOnSinglePage?: boolean;
}

const Pagination = ({
    pageNumber,
    pageCount,
    onSelected,
    showOnSinglePage = false,
}: PaginationProps) => {
    if (pageCount <= 1 && !showOnSinglePage) {
        return null;
    }

    const pages = Array.from({ length: pageCount }, (_, index) => index + 1);

    return (
        <nav className="trending-pagination" aria-label="Pagination">
            <button
                type="button"
                className="trending-pagination__nav"
                disabled={pageNumber <= 1}
                aria-label="Previous page"
                onClick={() => onSelected(pageNumber - 1)}
            >
                {'‹'}
            </button>
            {pages.map((page) => (
                <button
                    key={page}
                    type="button"
                    className={`trending-pagination__page${page === pageNumber ? ' active' : ''}`}
                    aria-current={page === pageNumber ? 'page' : undefined}
                    onClick={() => onSelected(page)}
                >
                    {page}
                </button>
            ))}
            <button
                type="button"
                className="trending-pagination__nav"
                disabled={pageNumber >= pageCount}
                aria-label="Next page"
                onClick={() => onSelected(pageNumber + 1)}
            >
                {'›'}
            </button>
        </nav>
    );
};

export default Pagination;
